// removed by extract-text-webpack-plugin
module.exports = {"BackgroundBox":"_21GlB","BackgroundBoxOne":"_3tx4u","BackgroundBoxTwo":"_1hR3J","BackgroundBoxThree":"_23bXQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Headers/SearchResultHeader/SearchResultHeaderBox/SearchResultHeaderBox.scss
// module id = 718
// module chunks = 0